import React from 'react';
import { Base } from './Base';
import { Text } from './Text';
import { MagCheckIcon } from './icons';
import { formatDate } from 'src/utils/misc';

interface EFComplianceAuditDueProps {
  showDate?: string;
  truncate?: boolean;
}

export const EFComplianceAuditDue: React.FC<EFComplianceAuditDueProps> = ({ showDate, truncate }) => {
  return (
    <Base
      iconComponent={<MagCheckIcon />}
      constentComponent={
        <Text nowrap={truncate}>
          {' '}
          {showDate && <Text className="sdate">{formatDate(showDate)}</Text>}Compliance audit due.
        </Text>
      }
    />
  );
};
